export const appConfig = {
  chatURL: 'https://va.uae.knovvu.com/webchat',
  kibanaURL: 'http://kibana.cai.sestek.localdev',
};
